module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_fruity_pears-a8944376.png";